// @ts-ignore
String.prototype.capitalize = function (char: string) {
  if (!char) return "";
  return char.charAt(0).toUpperCase() + char.slice(1);
};
